import { motion } from "framer-motion";

const COLORS = ["#FF5A5F", "#FFB21A", "#3EE6FF", "#7BD88F", "#FF6F91", "#7CC4FF"];

export const ConfettiBurst = ({ count = 40, spread = 260, testid = "confetti-burst", repeat = false }) => (
  <div data-testid={testid} aria-hidden className="pointer-events-none absolute inset-0 overflow-hidden">
    {Array.from({ length: count }, (_, i) => {
      const x = ((i * 37) % 100);
      const drift = (((i * 53) % 2 ? 1 : -1) * ((i * 29) % spread)) / 2;
      return (
        <motion.span key={i} className="absolute top-0 block rounded-[2px]"
          style={{ left: `${x}%`, width: 6 + (i % 3) * 3, height: 10 + (i % 4) * 3, background: COLORS[i % COLORS.length] }}
          initial={{ y: -30, x: 0, rotate: 0, opacity: 1 }}
          animate={{ y: [-30, 420], x: [0, drift], rotate: 360 + ((i * 47) % 360), opacity: [1, 1, 0] }}
          transition={{ duration: 2.4 + (i % 5) * 0.3, delay: (i % 10) * 0.12, ease: "easeIn", repeat: repeat ? Infinity : 0, repeatDelay: 0.6 }} />
      );
    })}
  </div>
);
